import React from 'react';import PropTypes from 'prop-types';

const subscriptionNames = [
    { name: 'RiksPakken', shortcut: 'RP', sub: '' },    
    { name: 'RiksPakken rabattert', shortcut: 'RP', sub: 'R' },    
    { name: 'Favoritter', shortcut: 'F', sub: '' },
    { name: 'Favoritter 2-4', shortcut: 'F', sub: '2-4' },
    { name: 'Favoritter (2-4)', shortcut: 'F', sub: '2-4' },
    { name: 'C more', shortcut: 'CM', sub: '' },
    { name: 'C more Play', shortcut: 'CMP', sub: '' },
    { name: 'C MORE rabattert', shortcut: 'CM', sub: 'R' },
    { name: 'C more Film and Series', shortcut: 'CMF', sub: '' },
    { name: 'C More Film & Serier', shortcut: 'CMF', sub: '' },
    { name: 'C More Film & Serier 2-4', shortcut: 'CMF', sub: '2-4' },    
    { name: 'C More Film & Serier (2-4)', shortcut: 'CMF', sub: '2-4' },    
    { name: '3 Favoritter', shortcut: '3F', sub: '' },
    { name: '3 Favoritter 2-4', shortcut: '3F', sub: '2-4' },
    { name: '3 Favoritter (2-4)', shortcut: '3F', sub: '2-4' },
    { name: '9 Favoritter', shortcut: '9F', sub: '' },
    { name: '9 Favoritter 2-4', shortcut: '9F', sub: '2-4' },
    { name: '9 Favoritter (2-4)', shortcut: '9F', sub: '2-4' },
    { name: '12 Favoritter', shortcut: '12F', sub: '' },
    { name: '12 Favoritter 2-4', shortcut: '12F', sub: '2-4' },
    { name: '12 Favoritter (2-4)', shortcut: '12F', sub: '2-4' },
    { name: 'TV2 Sport Premium', shortcut: 'S', sub: '' },
    { name: 'TV2 Sport Premium 2-4', shortcut: 'S', sub: '2-4' },
    { name: 'TV2 Sport Premium (2-4)', shortcut: 'S', sub: '2-4' },
    { name: 'TV 2 Sport Premium', shortcut: 'S', sub: '' },
    { name: 'TV 2 Sport Premium rabattert', shortcut: 'S', sub: 'R' },
    { name: 'TV 2 sport & Film', shortcut: 'SF', sub: '' },
    { name: 'TV 2 Sport & Film 2-4', shortcut: 'SF', sub: '2-4' },
    { name: 'TV 2 Sport & Film (2-4)', shortcut: 'SF', sub: '2-4' },
    { name: 'RiksPakken Basis', shortcut: 'RPB', sub: '' },
    { name: 'RiksPakken Basis rabattert', shortcut: 'RPB', sub: 'R' },
    { name: 'Månedskort', shortcut: 'M', sub: '' },
    { name: 'Månedskort 2 mnd', shortcut: 'M2', sub: '' },
    { name: 'Månedskort 3 mnd', shortcut: 'M3', sub: '' },
    { name: 'Månedskort 4 mnd', shortcut: 'M4', sub: '' },
    { name: 'RiksPakken OTT', shortcut: 'RPOTT', sub: '' },
    { name: 'RiksPakken OTT rabattert', shortcut: 'RPOTT', sub: 'R' },
    { name: 'Beat', shortcut: 'B', sub: '' },
    { name: 'Beat Familie', shortcut: 'BF', sub: '' },
    { name: 'Eurosport', shortcut: 'E', sub: '' },
    { name: 'Eurosport 2-4', shortcut: 'E', sub: '2-4' }
]

const findShortcutForSubscriptions = subscription => subscriptionNames.find(item =>
    item.name.toLowerCase() === subscription.name.toLowerCase())
    || { shortcut: subscription, sub: '' };

const SubscriptionElement = ({subscriptionlist}) => (
        <ul className="subscriptionList">
            {subscriptionlist.map((subscription, i) => {
                //const showlinkedSubscriptions = findShortcutForSubscriptions(subscription)
                return (
                    <li key={i}>
                        {subscription.name} ({subscription.commercialProductId})
                    </li>);
            })
            }
        </ul>
)


export default SubscriptionElement;